import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center lg:w-10/12 mx-auto rounded-md bg-dark-violet" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "lg:hidden w-full flex rounded",
  xmlns: "http://www.w3.org/2000/svg",
  width: "307",
  height: "158"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#4B3F6B",
    "fill-rule": "evenodd",
    d: "M0-.924C0 51.8 15.5 89.562 73 113.953c57.5 24.391 113.055 2.134 168.786 14.894 55.731 12.76 55.731 94.962 108.214 145.549s163.142 62.874 253.12 11.552C693.095 234.626 733.884 114.796 707 44.141 680.115-26.515 628.593-91 380-91 131.407-91 0-53.647 0-.924z"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "hidden w-full lg:flex mx-auto rounded",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1510",
  height: "128"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#4B3F6B",
    "fill-rule": "evenodd",
    d: "M647-93.924c0 52.724 15.5 90.486 73 114.877 57.5 24.391 113.055 2.134 168.786 14.894 55.731 12.76 55.731 94.962 108.214 145.549s163.142 62.874 253.12 11.552c89.976-51.322 130.765-171.152 103.88-241.807C1327.115-119.515 1275.593-184 1027-184c-248.593 0-380 37.353-380 90.076zm-781 213c0 52.724 15.5 90.486 73 114.877 57.5 24.391 113.055 2.134 168.786 14.894 55.731 12.76 55.731 94.962 108.214 145.549s163.142 62.874 253.12 11.552C559.095 354.626 599.884 234.796 573 164.141 546.115 93.485 494.593 29 246 29c-248.593 0-380 37.353-380 90.076z"
  })
], -1)
const _hoisted_4 = { class: "lg:flex absolute mx-auto grid self-center w-full lg:px-10 p-5 justify-items-center gap-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  placeholder: "Shorten a link here...",
  class: "px-5 py-4 lg:w-4/5 w-full rounded-md font-bold"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Shorten it!")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_buttons = _resolveComponent("buttons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_buttons, {
        name: "simple",
        class: "flex lg:w-1/4 w-full"
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ])
  ]))
}